
export default function Services() {
  const services = [
    {
      icon: 'ri-truck-line',
      title: 'Despacho Incluido Santiago',
      description: 'Entrega gratuita en toda la Región Metropolitana dentro de 24-48 horas.',
      color: 'bg-blue-100 text-blue-600'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Envíos a Todo Chile',
      description: 'Despachamos a cualquier región del país con tarifas preferenciales.',
      color: 'bg-green-100 text-green-600'
    },
    {
      icon: 'ri-tools-line',
      title: 'Instalación Profesional',
      description: 'Equipo técnico especializado para montaje rápido y seguro.',
      color: 'bg-purple-100 text-purple-600'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Garantía Extendida',
      description: 'Garantía de 2 años en estructura y 1 año en accesorios.',
      color: 'bg-orange-100 text-orange-600'
    },
    {
      icon: 'ri-calendar-line',
      title: 'Arriendo Flexible',
      description: 'Contratos desde 1 mes con opción de compra al finalizar.',
      color: 'bg-teal-100 text-teal-600'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Soporte 24/7',
      description: 'Atención técnica y comercial disponible todos los días.',
      color: 'bg-red-100 text-red-600'
    }
  ];

  return (
    <section id="servicios" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Nuestros Servicios
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ofrecemos un servicio integral que va más allá de la venta. Desde el despacho hasta la instalación y soporte técnico.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
              <div className={`w-12 h-12 ${service.color} rounded-lg flex items-center justify-center mb-4`}>
                <i className={`${service.icon} text-xl`}></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h4>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 lg:p-12 text-white text-center">
          <h4 className="text-3xl font-bold mb-4">¿Por qué elegir nuestros módulos?</h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
            <div>
              <div className="text-4xl font-bold mb-2">15+</div>
              <div className="text-blue-100">Años de experiencia</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">500+</div>
              <div className="text-blue-100">Proyectos completados</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">98%</div>
              <div className="text-blue-100">Clientes satisfechos</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
